import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=3e71401a&"
import script from "./Skin.vue?vue&type=script&lang=ts&"
export * from "./Skin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports